/**
 * Rutas que no exigen sesión Keycloak: callback OAuth, callbacks de pago y páginas /public.
 */
export function isPublicAppPath(path: string): boolean {
  const p = (path || '').split('?')[0];
  return p === '/callback' || p.startsWith('/callback/') || p === '/public' || p.startsWith('/public/');
}
